// extracted by mini-css-extract-plugin
module.exports = {"dpu-detail-R":"R_dpu-detail-R__LCJ6I"};